import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// 회사 상태 타입
export interface CompanyState {
  selectedCompany: string;
  availableCompanies: { value: string; label: string }[];
}

// 회사 액션 타입
interface CompanyActions {
  setSelectedCompany: (companyCode: string) => void;
  setAvailableCompanies: (
    companies: { value: string; label: string }[]
  ) => void;
  resetCompanyState: () => void;
}

// 초기 상태
const initialState: CompanyState = {
  selectedCompany: '',
  availableCompanies: [],
};

// Company store 생성
export const useCompanyStore = create<CompanyState & CompanyActions>()(
  persist(
    set => ({
      ...initialState,

      setSelectedCompany: (companyCode: string) =>
        set(state => ({
          ...state,
          selectedCompany: companyCode,
        })),

      setAvailableCompanies: (companies: { value: string; label: string }[]) =>
        set(state => ({
          ...state,
          availableCompanies: companies,
        })),

      resetCompanyState: () => set(initialState),
    }),
    {
      name: 'wjpnc-company-storage',
      partialize: state => {
        const {
          setSelectedCompany,
          setAvailableCompanies,
          resetCompanyState,
          ...persistedState
        } = state;
        return persistedState;
      },
    }
  )
);
